{
    "DATA_PLUGIN_ERROR": {
        "errorCode": 111029,
        "severity": "fatal",
        "params": {
            "p1": "store",
            "p2": "path",
            "p3": "value",
            "p4": "stack"
        }
    }
}
